var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"main-header"},[_c('Video',{attrs:{"videoSource":"../../assets/video/clouds.mp4"}}),_c('div',{staticClass:"main-header__countdown-box"},[_c('HeaderLogos'),_vm._m(0),_c('FlipCountdown2',{attrs:{"size":"big"}}),_c('p',[_vm._v("Please scroll down")]),_c('MouseScrollDown')],1)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',[_c('u',[_vm._v("Countdown to disseminate the warning")])])
}]

export { render, staticRenderFns }